import styled from '@emotion/styled';
import { nafColor } from '@nafcore/theme';
import { breakpoints, spacing } from '@naf/theme';

export const AppAnnouncementWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border: 1px solid ${nafColor.neutral.neutral3 || '#C1C1C1'};
  padding: ${spacing.space32} ${spacing.space24};
  margin-bottom: ${spacing.space32};
`;

export const AppIllustration = styled.div`
  margin-right: ${spacing.space32};

  @media (max-width: ${breakpoints.s}) {
    width: 100%;

    img {
      max-width: 67px;
    }
  }
`;

export const AppTextWrapper = styled.div`
  h2 {
    margin-top: 0;
  }
`;
